import { render, staticRenderFns } from "./PopupPaymentStudent.vue?vue&type=template&id=3ca5ff44&"
import script from "./PopupPaymentStudent.vue?vue&type=script&lang=js&"
export * from "./PopupPaymentStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports